<template>
  <section
    class="bg-[#232323] flex flex-col w-full items-center py-[61px] lg:py-[50px] px-[32px] lg:px-[100px] xl:py-[86.5px] sobre-backgorund">
    <div class="flex flex-col w-full gap-[29px] xl:w-[1280px] items-center lg:justify-center lg:max-w-[1058px]">

      <div class="flex flex-col w-full gap-[8px] items-center lg:flex-row lg:justify-between lg:py-[19px]">
        <h3 class="heading-35 text-center lg:text-left white2 xl:w-[434px]">
          Conheça um pouco da nossa empresa
        </h3>
        <p class="font-light !white2 text-center text-20 leading-[132%] lg:text-left !lg:w-[327px] shrink-0 ">
          Somos referência no setor de <br /> consignados
          Desde 2008.</p>
      </div>


      <div class="flex flex-col w-full items-center w-full gap-[14px] lg:flex-row">
        <div class="flex flex-col items-center w-full gap-[12px] lg:max-w-[685px]">
          <div
            class="relative flex flex-col gap-[5px] rounded-[9px] justify-end w-full h-[292px] px-[30px] py-[14px] bg-cover bg-center bg-[length:101%] hover:bg-[length:104%] transition-all duration-300 "
            :style="{ backgroundImage: 'url(/img/vip_staff.webp)' }">
            <div class="absolute inset-0 z-10 "
              :style="{ background: 'linear-gradient(180deg, rgba(38,38,38,0) 0%, rgba(0,0,0,0.72) 98.37%)' }"></div>

            <h3 class="z-[15] relative white font-bold text-[35px]"><strong class="yellow">+</strong>200</h3>
            <span class="z-[15] relative white font-light text-[20px]">colaboradores.</span>
          </div>

          <div class="flex flex-col items-center w-full gap-[12px] lg:flex-row lg:gap-[10px]">
            <div
              class="flex flex-col justify-center items-start h-[244px] rounded-[9px] p-[28px] lg:p-[15px] bg-[--yellow] w-full gap-[9px] lg:items-start group">
              <img src="/img/icons/stonks.svg"
                class="h-[36px] w-[36px] p-[6.5px] rounded-full bg-[--white] mb-[10px] group-hover:p-[4.5px] transition-all duration-500" />
              <h3 class="text-[--white] font-bold text-[35px] group-hover:text-[37px] transition-all duration-500 ">
                Desde 2008</h3>
              <span
                class="text-[20px] text-[--white] text-left font-light w-[235px] lg:text-left group-hover:text-[22px] transition-all duration-500 ">atuando
                no mercado de
                crédito.</span>
            </div>

            <div
              class="flex flex-col justify-center items-start h-[244px] rounded-[9px] p-[28px] lg:p-[15px] bg-[--white] w-full gap-[9px] lg:items-start group">
              <img src="/img/icons/star.svg"
                class="h-[36px] w-[36px] p-[8.5px] rounded-full bg-[--yellow] mb-[10px] group-hover:p-[6.5px] transition-all duration-500" />
              <h3 class="text-[--black] font-bold text-[35px] group-hover:text-[37px] transition-all duration-500">Nota
                4.9</h3>
              <span
                class="text-[20px] text-[--black] text-left font-light w-[235px] lg:text-left group-hover:text-[22px] transition-all duration-500">de
                avaliação no
                Google.</span>
            </div>
          </div>
        </div>

        <div
          class="w-full flex flex-col gap-[69px] pt-[83px] pb-[27px] bg-[#2A2929] rounded-[9px] lg:min-w-[291px] lg:max-w-[359px] lg:pb-[71px] lg:gap-[24px] group hover:lg:pb-[68px] transition-all duration-500">

          <div class="flex flex-col w-full gap-[12px]">
            <div class="relative !h-[48px] flex w-full overflow-x-hidden">
              <div
                class="absolute w-[244px] left-[-108px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[-83px] ">
              </div>
              <div
                class="absolute w-[48px] left-[151px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[176px] group-hover:bg-[--yellow]">
              </div>
              <div
                class="absolute w-[157px] left-[213px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[238px] ">
              </div>
            </div>
            <div class="relative h-[48px] flex w-full overflow-x-hidden">
              <div
                class="absolute w-[244px] left-[-176px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[-191px] ">
              </div>
              <div
                class="absolute w-[280px] left-[83px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[68px] group-hover:bg-[--white]">
              </div>
            </div>
            <div class="relative h-[48px] flex w-full overflow-x-hidden">
              <div
                class="absolute w-[296px] left-[-28px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[-13px] ">
              </div>
              <div
                class="absolute w-[48px] left-[283px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[298px] ">
              </div>
              <div
                class="absolute w-[170px] left-[344px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[359px] ">
              </div>
            </div>
            <div class="relative h-[48px] flex w-full overflow-x-hidden">
              <div
                class="absolute w-[296px] left-[-85px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[-120px] group-hover:bg-[--yellow]">
              </div>
              <div
                class="absolute w-[48px] left-[226px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[191px] ">
              </div>
              <div
                class="absolute w-[296px] left-[289px] h-[48px] rounded-full bg-[#353434] transition-all duration-500 group-hover:left-[254px] group-hover:bg-[--white]">
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-[9px] px-[28px]">
            <div class="flex ">
              <img src="/img/avatars/avatar1.webp"
                class="w-[36.6px] h-[36.6px] rounded-full transition-all duration-500 group-hover:w-[38.6px] group-hover:h-[38.6px]" />
              <img src="/img/avatars/avatar2.webp"
                class="w-[36.6px] h-[36.6px] rounded-full ml-[-12px] transition-all duration-500 group-hover:w-[38.6px] group-hover:h-[38.6px]" />
              <img src="/img/avatars/avatar3.webp"
                class="w-[36.6px] h-[36.6px] rounded-full ml-[-12px] transition-all duration-500 group-hover:w-[38.6px] group-hover:h-[38.6px]" />
              <img src="/img/avatars/avatar4.webp"
                class="w-[36.6px] h-[36.6px] rounded-full ml-[-12px] transition-all duration-500 group-hover:w-[38.6px] group-hover:h-[38.6px]" />
            </div>

            <h3 class="text-[--white] font-bold text-[35px] transition-all duration-500 group-hover:text-[37px] ">
              <strong class="yellow">+</strong>60mil
            </h3>
            <span
              class="text-[20px] leading-[132%] text-[--white] text-left font-light lg:text-left h-[49px] transition-all duration-500 group-hover:text-[22px]">clientes
              atendidos
              no mês.
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: "SectionHistory",
  data() {
    return {
      texts: [
        "Entre em contato com a Vip.",
        "Faça uma simulação gratuita.",
        "Leia o contrato e assine.",
        "Receba o valor dentro de algumas horas.",
      ],
    };
  },
};
</script>
